import { useTranslations } from 'next-intl';
import React from 'react';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { withOpacity } from '@cineamo/ui/src/helpers/color-helper';

type FormContactLinksProps = {
    domainConfiguration: DomainConfigurationDto;
    /** Form page namespace, e.g. `rent-a-cinema` — resolves `{namespace}.contact.phone`/`.email` translations. */
    namespace: string;
    phone?: string | null;
    phoneURI?: string | null;
    email?: string | null;
};

/**
 * "Questions? Call {phone}" style contact row shown on the OUR SERVICES form pages
 * (rent-a-cinema, kids-n-teens, birthday-at-the-cinema, reservation, buy-gift-cards).
 * Renders nothing when neither a phone nor an email could be resolved.
 */
const FormContactLinks: React.FC<FormContactLinksProps> = ({
    domainConfiguration,
    namespace,
    phone,
    phoneURI,
    email
}) => {
    const t = useTranslations();

    if (!phone && !email) {
        return null;
    }

    return (
        <div className="flex flex-col lg:flex-row justify-center items-center gap-4">
            {phone && (
                <div className="flex items-center space-x-2">
                    <span
                        className="text-body-14"
                        style={{ color: withOpacity(domainConfiguration.style.onBackgroundColor, 0.8) }}>
                        {t(`${namespace}.contact.phone`)}:
                    </span>
                    <a
                        href={phoneURI ?? undefined}
                        className="text-body-14 hover:opacity-80 transition-opacity"
                        style={{ color: domainConfiguration.style.primaryColor }}>
                        {phone}
                    </a>
                </div>
            )}
            {email && (
                <div className="flex items-center space-x-2">
                    <span
                        className="text-body-14"
                        style={{ color: withOpacity(domainConfiguration.style.onBackgroundColor, 0.8) }}>
                        {t(`${namespace}.contact.email`)}:
                    </span>
                    <a
                        href={`mailto:${email}`}
                        className="text-body-14 hover:opacity-80 transition-opacity"
                        style={{ color: domainConfiguration.style.primaryColor }}>
                        {email}
                    </a>
                </div>
            )}
        </div>
    );
};

export default FormContactLinks;
